module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/th_3-5ca58b5a54895bc04fdc7b8f7f00e3d3.jpg";